import React, { useEffect, useState } from "react";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  createTenantUsers,
  createUserRoleMap,
  createUsers,
  getRoles,
  uploadPlayerForm,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import ImagePreviewModal from "../../components/ImagePreviewModal";
import { Avatar } from "rsuite";

const AddUsers = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const mode = location.state?.mode || "add";
  const editUser = location.state?.user || null;
  const [errors, setErrors] = React.useState({});
  const [role, setRole] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileName, setPreviewFileName] = useState("");
  const [uploadedFormFiles, setUploadedFormFiles] = useState(null);
  const [uploadedImageFiles, setUploadedImageFiles] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    status: "",
    staffConsider: false,
  });

  useEffect(() => {
    if (mode === "edit" && editUser) {
      setFormData({
        name: editUser.user?.name || "",
        email: editUser.user?.email || "",
        phone: editUser.user?.phone || "",
        password: "", // keep empty in edit mode
        status: editUser.status || "active",
        staffConsider:
          typeof editUser?.staffConsider === "boolean"
            ? editUser.staffConsider
            : typeof editUser?.user?.staffConsider === "boolean"
              ? editUser.user.staffConsider
              : false,
      });

      setUploadedFormFiles(editUser.user?.avatar || null);

      // Set selected role from editUser (admin/user or roleId)
      setSelectedRole({
        value: editUser.tenantRole?.id,
        label: editUser.tenantRole?.name,
      });
    }
  }, [mode, editUser]);

  useEffect(() => {
    fetchRoles();
  }, []);

  async function fetchRoles() {
    try {
      const res = await getRoles();
      setRole(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.status) newErrors.status = "Status is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (
      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)
    ) {
      newErrors.email = "* Invalid email format";
    }
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!formData.password.trim() && mode !== "edit")
      newErrors.password = "Password is required";
    if (!selectedRole) newErrors.role = "Role is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  const handleFormFileChange = async (e) => {
    try {
      const file = e.target.files[0]; //single file
      if (!file) return;

      //Upload to API
      const res = await uploadPlayerForm(file);

      //REPLACE instead of append
      setUploadedFormFiles(res);
    } catch (error) {
      console.error("Image upload failed:", error);
    }
  };

  async function handleSubmit() {
    if (!validate()) return;

    try {
      setLoading(true);
      const payloadd = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        roleId: selectedRole?.value,
        staffConsider: Boolean(formData.staffConsider),
        status: formData.status,
        avatar: uploadedImageFiles,
      };

      if (mode === "edit") {
        payloadd.id = editUser.user?.id;
      }

      console.log("FINAL payload:", payloadd);

      const userResponse = await createUsers(payloadd);

      if (userResponse && userResponse.id) {
        const rolePayload = {
          userId: userResponse.id,
          tenantRoleId: selectedRole?.value,
        };

        toast.success(
          mode === "edit"
            ? "User Updated successfully!"
            : "User Created successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        await createUserRoleMap(rolePayload);
        navigate("/admin/all-users");
      }
    } catch (error) {
      console.error("Error submitting user data:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // Clear error for the field
  };

  const handleStatusChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      status: selected?.value || "",
    }));
    setErrors((prev) => ({ ...prev, status: "" }));
  };

  const handleStaffConsiderChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      staffConsider: e.target.checked,
    }));
  };

  return (
    <>
      {/* <PageTitle activeMenu={"Add Users"} motherMenu={"Users"} /> */}
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">{editUser ? "Edit" : "Add"} User</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/all-users">Users</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link> {editUser ? "Edit" : "Add"} User</Link>
          </li>
        </ol>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">{editUser ? "Edit" : "Add"} User</h4>
            </div>
            <div className="card-body">
              <form autoComplete="off">
                {/* Decoy fields to prevent browser autofill */}
                <div
                  style={{
                    position: "absolute",
                    top: "-9999px",
                    left: "-9999px",
                    opacity: 0,
                    height: 0,
                    width: 0,
                    overflow: "hidden",
                  }}
                  aria-hidden="true"
                >
                  <input
                    type="text"
                    name="fake_username_autofill"
                    tabIndex={-1}
                    autoComplete="off"
                  />
                  <input
                    type="password"
                    name="fake_password_autofill"
                    tabIndex={-1}
                    autoComplete="new-password"
                  />
                </div>

                <div className="row">
                  {/* Tournament Name */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        id="name"
                        placeholder="Enter Name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        required
                      />
                      {errors.name && (
                        <small className="text-danger m-lg-2">
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Role <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        value={selectedRole}
                        options={role?.map((type) => ({
                          value: type.id,
                          label: type.name,
                        }))}
                        onChange={(d) => {
                          setSelectedRole(d);
                          setErrors((prev) => ({ ...prev, role: "" }));
                        }}
                        placeholder="Select Role"
                        className="custom-react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.role
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.role
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.role
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.role && (
                        <small className="text-danger m-lg-2">
                          {errors.role}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="email">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        id="email"
                        placeholder="Enter Email"
                        type="email"
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        name="email"
                        autoComplete="off"
                        value={formData.email}
                        onChange={handleChange}
                        readOnly={mode === "edit"} // Make email readonly in edit mode
                        required
                      />
                      {errors.email && (
                        <small className="text-danger m-lg-2">
                          {errors.email}
                        </small>
                      )}
                    </div>
                  </div>

                  {mode !== "edit" && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="pwd">
                          Password <span className="required">*</span>
                        </label>
                        <div className="input-group pass-group">
                          <input
                            placeholder="Enter Password"
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            className="form-control pass-input"
                            style={
                              errors.password
                                ? {
                                    borderColor: "#dc3545",
                                    borderRight: "none",
                                  }
                                : {}
                            }
                            autoComplete="new-password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />

                          <span
                            className={`input-group-text pass-handle ${
                              showPassword ? "active" : ""
                            }`}
                            onClick={() => setShowPassword(!showPassword)}
                            style={
                              errors.password
                                ? {
                                    borderColor: "#dc3545",
                                    borderLeft: "none",
                                  }
                                : {}
                            }
                          >
                            <i className="fa fa-eye-slash" />
                            <i className="fa fa-eye" />
                          </span>
                        </div>

                        {errors.password && (
                          <small className="text-danger m-lg-2">
                            {errors.password}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="mobileNo">
                        Mobile No <span className="required">*</span>
                      </label>
                      <input
                        id="mobileNo"
                        placeholder="Enter Mobile Number"
                        type="number"
                        className={`form-control ${
                          errors.phone ? "is-invalid" : ""
                        }`}
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                      {errors.phone && (
                        <small className="text-danger m-lg-2">
                          {errors.phone}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Status <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={[
                          { value: "ACTIVE", label: "Active" },
                          { value: "INACTIVE", label: "Inactive" },
                        ]}
                        placeholder="Select Status"
                        className="custom-react-select"
                        value={
                          formData.status
                            ? {
                                value: formData.status,
                                label:
                                  formData.status === "ACTIVE"
                                    ? "Active"
                                    : "Inactive",
                              }
                            : null
                        }
                        onChange={handleStatusChange}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.status
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.status
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.status
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.status && (
                        <small className="text-danger m-lg-2">
                          {errors.status}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group fallback w-100">
                      <label className="form-label">User Image</label>
                      <input
                        id="userImage"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFormFileChange}
                      />
                    </div>
                  </div>
                  <div className="form-check custom-checkbox ms-4 mb-4">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="basic_checkbox_1"
                      checked={Boolean(formData.staffConsider)}
                      onChange={handleStaffConsiderChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="basic_checkbox_1"
                    >
                      Consider as a staff
                    </label>
                  </div>
                  <div className="col-sm-12 flex-row d-flex gap-4">
                    {uploadedImageFiles && (
                      <div className="col-sm-6">
                        <h6>Upload Image</h6>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                            {/* File Name on the Left */}
                            <div
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {uploadedImageFiles?.fileName}
                            </div>

                            {/* Action Buttons on the Right */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                title="View"
                                onClick={() => {
                                  setPreviewFileName(
                                    uploadedImageFiles.fileName,
                                  );
                                  setPreviewModal(true);
                                }}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => setUploadedImageFiles(null)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {uploadedFormFiles && (
                      <div className="col-sm-6">
                        <h6>Image File</h6>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                            {/* File Name on the Left */}
                            <div
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {uploadedFormFiles?.fileName}
                            </div>

                            {/* Action Buttons on the Right */}
                            <div className="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                title="View"
                                onClick={() => {
                                  setPreviewFileName(
                                    uploadedFormFiles.fileName,
                                  );
                                  setPreviewModal(true);
                                }}
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                title="Delete"
                                onClick={() => setUploadedFormFiles(null)}
                              >
                                <i className="fa fa-trash" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="button"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                    <Link
                      to="/admin/all-users"
                      className="btn btn-danger light"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ImagePreviewModal
        show={previewModal}
        onClose={() => setPreviewModal(false)}
        fileName={previewFileName}
      />
    </>
  );
};

export default AddUsers;
